import { baseApi, API_TAGS, createCacheTags, createEndpointBuilder, type Params } from '@/shared/api';

import type { ReceiveHistoryInfiniteQueryArgs, ReceiveHistoryPageResponse } from '../model/history-types';

const receiveEndpoint = createEndpointBuilder('/api/v2/receive');

/**
 * Receive History list endpoint (`GET /api/v2/receive/history`). Lives in its
 * own injectEndpoints call, separate from `receiveApi`, so the history slice
 * stays self-contained next to the dashboard endpoints.
 */
export const receiveHistoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReceiveHistory: builder.infiniteQuery<ReceiveHistoryPageResponse, ReceiveHistoryInfiniteQueryArgs, number>({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: (lastPage, _allPages, lastPageParam) => {
          const nextPage = lastPageParam + 1;
          if (nextPage >= lastPage.totalPages) {
            return undefined;
          }
          return nextPage;
        }
      },
      query: ({ queryArg, pageParam }) => ({
        url: receiveEndpoint('/history'),
        params: {
          ...queryArg,
          page: pageParam
        }
      }),
      providesTags: (_result, _error, { queryArg }) =>
        createCacheTags({
          baseTag: API_TAGS.RECEIVE,
          params: queryArg as unknown as Params
        })
    })
  })
});

export const { useGetReceiveHistoryInfiniteQuery } = receiveHistoryApi;
